<template>
  <div class="ubicacion-selector">
    <div class="ubicacion-selector__grid">
      <div class="ubicacion-selector__field">
        <label v-if="mostrarLabels" class="ubicacion-selector__label">Almacén</label>
        <select
          class="ubicacion-selector__input ubicacion-selector__input--compact"
          :disabled="disabled || !!almacenFijoId"
          :value="almacenSeleccionado"
          @change="onAlmacenChange($event.target.value)"
        >
          <option value="">Selecciona almacén…</option>
          <option
            v-for="almacen in almacenes"
            :key="almacen.id_almacen"
            :value="almacen.id_almacen"
          >
            {{ almacen.nombre }}
          </option>
        </select>
      </div>

      <div class="ubicacion-selector__field">
        <label v-if="mostrarLabels" class="ubicacion-selector__label">Nivel 1</label>
        <div class="ubicacion-selector__dropdown">
          <button
            type="button"
            class="ubicacion-selector__control"
            :disabled="disabled || !almacenSeleccionado"
            @click="toggleDropdown('nivel1')"
          >
            <span :class="{ 'is-placeholder': !labelNivel1 }">
              {{ labelNivel1 || 'Selecciona o crea nivel 1…' }}
            </span>
            <span class="ubicacion-selector__control-icon">⌄</span>
          </button>

          <div
            v-if="dropdownAbierto === 'nivel1'"
            class="ubicacion-selector__menu"
            @click.stop
          >
            <input
              ref="dropdownSearchNivel1"
              v-model.trim="filtrosDropdown.nivel1"
              class="ubicacion-selector__search"
              type="text"
              placeholder="Buscar nivel 1…"
            />
            <div class="ubicacion-selector__options">
              <button
                v-for="opt in opcionesNivel1Filtradas"
                :key="'n1-'+opt"
                type="button"
                class="ubicacion-selector__option"
                :class="{ 'is-selected': normalizar(opt) === nivel1Actual && nivel1Seleccion !== '__nuevo__' }"
                @click="seleccionarNivel('nivel1', opt)"
              >
                {{ opt }}
              </button>

              <button
                v-if="puedeCrearNivel1"
                type="button"
                class="ubicacion-selector__option ubicacion-selector__option--create"
                @click="activarNuevoNivel('nivel1')"
              >
                + Crear “{{ filtrosDropdown.nivel1 }}”
              </button>

              <p v-if="!opcionesNivel1Filtradas.length && !puedeCrearNivel1" class="ubicacion-selector__empty">
                No hay coincidencias.
              </p>
            </div>
          </div>
        </div>

        <input
          v-if="nivel1Seleccion === '__nuevo__'"
          v-model.trim="nuevoNivel1"
          class="ubicacion-selector__input ubicacion-selector__input--compact ubicacion-selector__input--sub"
          :disabled="disabled"
          placeholder="Escribe el nuevo nivel 1"
          @input="onDraftChange"
        />
      </div>
    </div>

    <div class="ubicacion-selector__grid">
      <div class="ubicacion-selector__field">
        <label v-if="mostrarLabels" class="ubicacion-selector__label">Nivel 2</label>
        <div class="ubicacion-selector__dropdown">
          <button
            type="button"
            class="ubicacion-selector__control"
            :disabled="disabled || !nivel1Actual"
            @click="toggleDropdown('nivel2')"
          >
            <span :class="{ 'is-placeholder': !labelNivel2 }">
              {{ labelNivel2 || 'Sin nivel 2' }}
            </span>
            <span class="ubicacion-selector__control-icon">⌄</span>
          </button>

          <div
            v-if="dropdownAbierto === 'nivel2'"
            class="ubicacion-selector__menu"
            @click.stop
          >
            <input
              ref="dropdownSearchNivel2"
              v-model.trim="filtrosDropdown.nivel2"
              class="ubicacion-selector__search"
              type="text"
              placeholder="Buscar nivel 2…"
            />
            <div class="ubicacion-selector__options">
              <button
                type="button"
                class="ubicacion-selector__option"
                :class="{ 'is-selected': !nivel2Actual && nivel2Seleccion !== '__nuevo__' }"
                @click="seleccionarNivel('nivel2', '')"
              >
                Sin nivel 2
              </button>

              <button
                v-for="opt in opcionesNivel2Filtradas"
                :key="'n2-'+opt"
                type="button"
                class="ubicacion-selector__option"
                :class="{ 'is-selected': normalizar(opt) === nivel2Actual && nivel2Seleccion !== '__nuevo__' }"
                @click="seleccionarNivel('nivel2', opt)"
              >
                {{ opt }}
              </button>

              <button
                v-if="puedeCrearNivel2"
                type="button"
                class="ubicacion-selector__option ubicacion-selector__option--create"
                @click="activarNuevoNivel('nivel2')"
              >
                + Crear “{{ filtrosDropdown.nivel2 }}”
              </button>

              <p v-if="!opcionesNivel2Filtradas.length && !puedeCrearNivel2 && filtrosDropdown.nivel2" class="ubicacion-selector__empty">
                No hay coincidencias.
              </p>
            </div>
          </div>
        </div>

        <input
          v-if="nivel2Seleccion === '__nuevo__'"
          v-model.trim="nuevoNivel2"
          class="ubicacion-selector__input ubicacion-selector__input--compact ubicacion-selector__input--sub"
          :disabled="disabled"
          placeholder="Escribe el nuevo nivel 2"
          @input="onDraftChange"
        />
      </div>

      <div class="ubicacion-selector__field">
        <label v-if="mostrarLabels" class="ubicacion-selector__label">Nivel 3</label>
        <div class="ubicacion-selector__dropdown">
          <button
            type="button"
            class="ubicacion-selector__control"
            :disabled="disabled || !nivel2Actual"
            @click="toggleDropdown('nivel3')"
          >
            <span :class="{ 'is-placeholder': !labelNivel3 }">
              {{ labelNivel3 || 'Sin nivel 3' }}
            </span>
            <span class="ubicacion-selector__control-icon">⌄</span>
          </button>

          <div
            v-if="dropdownAbierto === 'nivel3'"
            class="ubicacion-selector__menu"
            @click.stop
          >
            <input
              ref="dropdownSearchNivel3"
              v-model.trim="filtrosDropdown.nivel3"
              class="ubicacion-selector__search"
              type="text"
              placeholder="Buscar o crear nivel 3…"
            />
            <div class="ubicacion-selector__options">
              <button
                type="button"
                class="ubicacion-selector__option"
                :class="{ 'is-selected': !nivel3Actual && nivel3Seleccion !== '__nuevo__' }"
                @click="seleccionarNivel('nivel3', '')"
              >
                Sin nivel 3
              </button>

              <button
                v-for="opt in opcionesNivel3Filtradas"
                :key="'n3-'+opt"
                type="button"
                class="ubicacion-selector__option"
                :class="{ 'is-selected': normalizar(opt) === nivel3Actual && nivel3Seleccion !== '__nuevo__' }"
                @click="seleccionarNivel('nivel3', opt)"
              >
                {{ opt }}
              </button>

              <button
                v-if="puedeCrearNivel3"
                type="button"
                class="ubicacion-selector__option ubicacion-selector__option--create"
                @click="activarNuevoNivel('nivel3')"
              >
                + Crear “{{ filtrosDropdown.nivel3 }}”
              </button>

              <p v-if="!opcionesNivel3Filtradas.length && !puedeCrearNivel3 && filtrosDropdown.nivel3" class="ubicacion-selector__empty">
                No hay coincidencias.
              </p>
            </div>
          </div>
        </div>

        <input
          v-if="nivel3Seleccion === '__nuevo__'"
          v-model.trim="nuevoNivel3"
          class="ubicacion-selector__input ubicacion-selector__input--compact ubicacion-selector__input--sub"
          :disabled="disabled"
          placeholder="Escribe el nuevo nivel 3"
          @input="onDraftChange"
        />
      </div>
    </div>

    <textarea
      v-if="permitirCrear && mostrarReferencia"
      v-model.trim="referenciaLocal"
      class="ubicacion-selector__input ubicacion-selector__input--compact ubicacion-selector__textarea"
      :disabled="disabled"
      rows="2"
      placeholder="Referencia opcional de la ubicación"
    ></textarea>

    <div class="ubicacion-selector__meta">
      <div class="ubicacion-selector__summary">
        <span v-if="ubicacionActual" class="ubicacion-selector__chip">
          {{ ubicacionActual.ubicacion_label }}
        </span>
        <span v-else-if="rutaPreview" class="ubicacion-selector__chip ubicacion-selector__chip--draft">
          {{ rutaPreview }}
        </span>
        <span v-if="mensajeEstado" class="ubicacion-selector__hint" :class="estadoClase">
          {{ mensajeEstado }}
        </span>
      </div>

      <div class="ubicacion-selector__actions">
        <button
          v-if="permitirCrear && puedeCrearNueva"
          type="button"
          class="ubicacion-selector__action ubicacion-selector__action--primary"
          :disabled="disabled || guardando"
          @click="crearUbicacion"
        >
          {{ guardando ? 'Guardando…' : 'Crear ubicación' }}
        </button>

        <button
          v-if="permitirLimpiar && (almacenSeleccionado || valorUbicacion)"
          type="button"
          class="ubicacion-selector__action"
          :disabled="disabled"
          @click="limpiar"
        >
          Limpiar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'SelectorUbicacionAlmacen',
  props: {
    modelValue: {
      type: Object,
      default: () => ({ id_almacen: '', id_ubicacion_almacen: '' }),
    },
    almacenes: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    mostrarLabels: {
      type: Boolean,
      default: true,
    },
    permitirLimpiar: {
      type: Boolean,
      default: true,
    },
    permitirCrear: {
      type: Boolean,
      default: true,
    },
    mostrarReferencia: {
      type: Boolean,
      default: false,
    },
    almacenFijoId: {
      type: [String, Number],
      default: '',
    },
  },
  emits: ['update:modelValue', 'change', 'created'],
  data() {
    return {
      nivel1Seleccion: '',
      nivel2Seleccion: '',
      nivel3Seleccion: '',
      nuevoNivel1: '',
      nuevoNivel2: '',
      nuevoNivel3: '',
      referenciaLocal: '',
      guardando: false,
      mensajeEstado: '',
      estadoClase: '',
      ultimoAlmacenSincronizado: '',
      ultimaUbicacionSincronizada: '',
      dropdownAbierto: '',
      filtrosDropdown: {
        nivel1: '',
        nivel2: '',
        nivel3: '',
      },
      ultimoEmitidoInterno: {
        id_almacen: '',
        id_ubicacion_almacen: '',
      },
    };
  },
  computed: {
    valorAlmacen() {
      return this.modelValue?.id_almacen || '';
    },
    valorUbicacion() {
      return this.modelValue?.id_ubicacion_almacen || '';
    },
    almacenSeleccionado() {
      return this.almacenFijoId || this.valorAlmacen || '';
    },
    almacenActual() {
      return (this.almacenes || []).find(
        (a) => Number(a.id_almacen) === Number(this.almacenSeleccionado),
      ) || null;
    },
    ubicacionesDisponibles() {
      return this.almacenActual?.ubicaciones || [];
    },
    opcionesNivel1() {
      return this.distintos(this.ubicacionesDisponibles.map((u) => u.nivel_1));
    },
    opcionesNivel1Filtradas() {
      return this.filtrarOpciones(this.opcionesNivel1, this.filtrosDropdown.nivel1);
    },
    nivel1Actual() {
      return this.nivel1Seleccion === '__nuevo__'
        ? this.normalizar(this.nuevoNivel1)
        : this.normalizar(this.nivel1Seleccion);
    },
    opcionesNivel2() {
      if (!this.nivel1Actual) return [];
      return this.distintos(
        this.ubicacionesDisponibles
          .filter((u) => this.normalizar(u.nivel_1) === this.nivel1Actual)
          .map((u) => u.nivel_2)
          .filter(Boolean),
      );
    },
    opcionesNivel2Filtradas() {
      return this.filtrarOpciones(this.opcionesNivel2, this.filtrosDropdown.nivel2);
    },
    nivel2Actual() {
      return this.nivel2Seleccion === '__nuevo__'
        ? this.normalizar(this.nuevoNivel2)
        : this.normalizar(this.nivel2Seleccion);
    },
    opcionesNivel3() {
      if (!this.nivel1Actual || !this.nivel2Actual) return [];
      return this.distintos(
        this.ubicacionesDisponibles
          .filter(
            (u) => this.normalizar(u.nivel_1) === this.nivel1Actual
              && this.normalizar(u.nivel_2) === this.nivel2Actual,
          )
          .map((u) => u.nivel_3)
          .filter(Boolean),
      );
    },
    opcionesNivel3Filtradas() {
      return this.filtrarOpciones(this.opcionesNivel3, this.filtrosDropdown.nivel3);
    },
    nivel3Actual() {
      return this.nivel3Seleccion === '__nuevo__'
        ? this.normalizar(this.nuevoNivel3)
        : this.normalizar(this.nivel3Seleccion);
    },
    coincidenciaExacta() {
      if (!this.almacenSeleccionado || !this.nivel1Actual) return null;
      return this.ubicacionesDisponibles.find((u) =>
        this.normalizar(u.nivel_1) === this.nivel1Actual
        && this.normalizar(u.nivel_2) === this.nivel2Actual
        && this.normalizar(u.nivel_3) === this.nivel3Actual,
      ) || null;
    },
    ubicacionActual() {
      if (this.valorUbicacion) {
        return this.ubicacionesDisponibles.find(
          (u) => Number(u.id_ubicacion_almacen) === Number(this.valorUbicacion),
        ) || this.coincidenciaExacta;
      }
      return this.coincidenciaExacta;
    },
    rutaPreview() {
      if (!this.almacenActual || !this.nivel1Actual) return '';
      return [this.almacenActual.nombre, this.nivel1Actual, this.nivel2Actual, this.nivel3Actual]
        .filter(Boolean)
        .join(' → ');
    },
    rutaValidaParaCrear() {
      if (!this.almacenSeleccionado || !this.nivel1Actual) return false;
      if (this.nivel3Actual && !this.nivel2Actual) return false;
      return true;
    },
    usaModoNuevo() {
      return [this.nivel1Seleccion, this.nivel2Seleccion, this.nivel3Seleccion].includes('__nuevo__');
    },
    puedeCrearNueva() {
      return this.permitirCrear && this.rutaValidaParaCrear && !this.coincidenciaExacta && this.usaModoNuevo;
    },
    idsActuales() {
      return {
        id_almacen: this.almacenSeleccionado || '',
        id_ubicacion_almacen: this.coincidenciaExacta?.id_ubicacion_almacen || '',
      };
    },
    puedeCrearNivel1() {
      const texto = this.normalizar(this.filtrosDropdown.nivel1);
      return this.permitirCrear && !!texto && !this.existeOpcionExacta(this.opcionesNivel1, texto);
    },
    puedeCrearNivel2() {
      const texto = this.normalizar(this.filtrosDropdown.nivel2);
      return this.permitirCrear && !!this.nivel1Actual && !!texto && !this.existeOpcionExacta(this.opcionesNivel2, texto);
    },
    puedeCrearNivel3() {
      const texto = this.normalizar(this.filtrosDropdown.nivel3);
      return this.permitirCrear && !!this.nivel2Actual && !!texto && !this.existeOpcionExacta(this.opcionesNivel3, texto);
    },
    labelNivel1() {
      return this.nivel1Seleccion === '__nuevo__'
        ? this.nuevoNivel1
        : this.nivel1Seleccion;
    },
    labelNivel2() {
      return this.nivel2Seleccion === '__nuevo__'
        ? this.nuevoNivel2
        : this.nivel2Seleccion;
    },
    labelNivel3() {
      return this.nivel3Seleccion === '__nuevo__'
        ? this.nuevoNivel3
        : this.nivel3Seleccion;
    },
  },
  watch: {
    valorAlmacen: {
      immediate: true,
      handler() {
        this.sincronizarDesdeModelo();
      },
    },
    valorUbicacion() {
      this.sincronizarDesdeModelo();
    },
    almacenFijoId() {
      this.sincronizarDesdeModelo();
    },
    almacenes: {
      deep: true,
      handler() {
        this.sincronizarDesdeModelo();
      },
    },
  },
  mounted() {
    document.addEventListener('mousedown', this.onClickFuera);
  },
  beforeUnmount() {
    document.removeEventListener('mousedown', this.onClickFuera);
  },
  methods: {
    distintos(arr) {
      return [...new Set((arr || []).map((v) => this.normalizar(v)).filter(Boolean))]
        .sort((a, b) => a.localeCompare(b, 'es'));
    },
    normalizar(value) {
      const v = String(value || '').trim();
      return v || '';
    },
    filtrarOpciones(opciones, termino) {
      const q = this.normalizar(termino).toLowerCase();
      if (!q) return opciones || [];
      return (opciones || []).filter((opt) => String(opt || '').toLowerCase().includes(q));
    },
    existeOpcionExacta(opciones, termino) {
      const q = this.normalizar(termino).toLowerCase();
      return (opciones || []).some((opt) => this.normalizar(opt).toLowerCase() === q);
    },
    emitir(value) {
      const payload = {
        id_almacen: value?.id_almacen || '',
        id_ubicacion_almacen: value?.id_ubicacion_almacen || '',
      };
      if (
        String(payload.id_almacen || '') === String(this.valorAlmacen || '')
        && String(payload.id_ubicacion_almacen || '') === String(this.valorUbicacion || '')
      ) {
        return;
      }
      this.ultimoEmitidoInterno = { ...payload };
      this.$emit('update:modelValue', payload);
      this.$emit('change', payload);
    },
    sincronizarDesdeModelo() {
      const almacenId = this.almacenFijoId || this.valorAlmacen || '';
      const ubicacion = (this.almacenes || [])
        .flatMap((a) => a.ubicaciones || [])
        .find((u) => Number(u.id_ubicacion_almacen) === Number(this.valorUbicacion));

      const esEcoInterno = (
        String(almacenId || '') === String(this.ultimoEmitidoInterno?.id_almacen || '')
        && String(this.valorUbicacion || '') === String(this.ultimoEmitidoInterno?.id_ubicacion_almacen || '')
      );

      const cambioAlmacenExterno = (
        String(almacenId || '') !== String(this.ultimoAlmacenSincronizado || '')
        && !esEcoInterno
      );
      const cambioUbicacionExterno = (
        String(this.valorUbicacion || '') !== String(this.ultimaUbicacionSincronizada || '')
        && !esEcoInterno
      );

      if (!almacenId) {
        this.resetDraft(false, true);
        this.ultimoAlmacenSincronizado = '';
        this.ultimaUbicacionSincronizada = '';
        this.ultimoEmitidoInterno = { id_almacen: '', id_ubicacion_almacen: '' };
        return;
      }

      if (ubicacion) {
        this.nivel1Seleccion = ubicacion.nivel_1 || '';
        this.nuevoNivel1 = '';
        this.nivel2Seleccion = ubicacion.nivel_2 || '';
        this.nuevoNivel2 = '';
        this.nivel3Seleccion = ubicacion.nivel_3 || '';
        this.nuevoNivel3 = '';
        this.referenciaLocal = ubicacion.referencia || '';
        this.filtrosDropdown.nivel1 = '';
        this.filtrosDropdown.nivel2 = '';
        this.filtrosDropdown.nivel3 = '';
        this.ultimoAlmacenSincronizado = almacenId;
        this.ultimaUbicacionSincronizada = this.valorUbicacion || '';
        this.actualizarEstado();
        return;
      }

      if (cambioAlmacenExterno || cambioUbicacionExterno) {
        this.resetDraft(false, false);
      }

      this.ultimoAlmacenSincronizado = almacenId;
      this.ultimaUbicacionSincronizada = this.valorUbicacion || '';
      this.actualizarEstado();
    },
    resetDraft(emitirCambio = true, limpiarAlmacen = false) {
      this.nivel1Seleccion = '';
      this.nivel2Seleccion = '';
      this.nivel3Seleccion = '';
      this.nuevoNivel1 = '';
      this.nuevoNivel2 = '';
      this.nuevoNivel3 = '';
      this.filtrosDropdown.nivel1 = '';
      this.filtrosDropdown.nivel2 = '';
      this.filtrosDropdown.nivel3 = '';
      this.referenciaLocal = '';
      this.mensajeEstado = '';
      this.estadoClase = '';
      this.dropdownAbierto = '';

      if (emitirCambio) {
        this.emitir({
          id_almacen: limpiarAlmacen ? '' : (this.almacenFijoId || this.valorAlmacen || ''),
          id_ubicacion_almacen: '',
        });
      }
    },
    actualizarEstado() {
      if (this.coincidenciaExacta) {
        this.mensajeEstado = 'Ubicación existente lista para usarse.';
        this.estadoClase = 'ubicacion-selector__hint--ok';
      } else if (this.rutaPreview && this.rutaValidaParaCrear) {
        if (this.usaModoNuevo) {
          this.mensajeEstado = 'Esta combinación aún no existe. Puedes crearla desde aquí.';
          this.estadoClase = 'ubicacion-selector__hint--warn';
        } else {
          this.mensajeEstado = 'Selecciona una ubicación final existente o crea el siguiente nivel.';
          this.estadoClase = '';
        }
      } else if (this.almacenSeleccionado && !this.nivel1Actual) {
        this.mensajeEstado = 'Selecciona un nivel 1 o crea uno nuevo para comenzar la ruta.';
        this.estadoClase = '';
      } else if (this.nivel3Actual && !this.nivel2Actual) {
        this.mensajeEstado = 'No puedes usar nivel 3 sin haber definido antes el nivel 2.';
        this.estadoClase = 'ubicacion-selector__hint--error';
      } else {
        this.mensajeEstado = '';
        this.estadoClase = '';
      }
    },
    actualizarSeleccionEmitida() {
      this.actualizarEstado();
      this.emitir(this.idsActuales);
    },
    onAlmacenChange(value) {
      this.resetDraft(false, false);
      this.emitir({ id_almacen: value || '', id_ubicacion_almacen: '' });
    },
    onNivel1Change() {
      this.nuevoNivel1 = this.nivel1Seleccion === '__nuevo__' ? this.nuevoNivel1 : '';
      this.nivel2Seleccion = '';
      this.nuevoNivel2 = '';
      this.nivel3Seleccion = '';
      this.nuevoNivel3 = '';
      this.filtrosDropdown.nivel2 = '';
      this.filtrosDropdown.nivel3 = '';
      this.dropdownAbierto = '';
      this.actualizarSeleccionEmitida();
    },
    onNivel2Change() {
      this.nuevoNivel2 = this.nivel2Seleccion === '__nuevo__' ? this.nuevoNivel2 : '';
      this.nivel3Seleccion = '';
      this.nuevoNivel3 = '';
      this.filtrosDropdown.nivel3 = '';
      this.dropdownAbierto = '';
      this.actualizarSeleccionEmitida();
    },
    onNivel3Change() {
      this.nuevoNivel3 = this.nivel3Seleccion === '__nuevo__' ? this.nuevoNivel3 : '';
      this.dropdownAbierto = '';
      this.actualizarSeleccionEmitida();
    },
    onDraftChange() {
      this.actualizarSeleccionEmitida();
    },
    toggleDropdown(key) {
      if (this.disabled) return;
      if (key === 'nivel1' && !this.almacenSeleccionado) return;
      if (key === 'nivel2' && !this.nivel1Actual) return;
      if (key === 'nivel3' && !this.nivel2Actual) return;

      this.dropdownAbierto = this.dropdownAbierto === key ? '' : key;
      if (this.dropdownAbierto) {
        this.$nextTick(() => {
          const refName = `dropdownSearch${key.charAt(0).toUpperCase()}${key.slice(1)}`;
          const input = this.$refs[refName];
          if (input && typeof input.focus === 'function') {
            input.focus();
          }
        });
      }
    },
    seleccionarNivel(key, value) {
      if (key === 'nivel1') {
        this.nivel1Seleccion = value;
        this.filtrosDropdown.nivel1 = '';
        this.onNivel1Change();
      } else if (key === 'nivel2') {
        this.nivel2Seleccion = value;
        this.filtrosDropdown.nivel2 = '';
        this.onNivel2Change();
      } else if (key === 'nivel3') {
        this.nivel3Seleccion = value;
        this.filtrosDropdown.nivel3 = '';
        this.onNivel3Change();
      }
    },
    activarNuevoNivel(key) {
      const valor = this.normalizar(this.filtrosDropdown[key]);
      if (!valor) return;

      if (key === 'nivel1') {
        this.nivel1Seleccion = '__nuevo__';
        this.nuevoNivel1 = valor;
        this.onNivel1Change();
      } else if (key === 'nivel2') {
        this.nivel2Seleccion = '__nuevo__';
        this.nuevoNivel2 = valor;
        this.onNivel2Change();
      } else if (key === 'nivel3') {
        this.nivel3Seleccion = '__nuevo__';
        this.nuevoNivel3 = valor;
        this.onNivel3Change();
      }
    },
    onClickFuera(event) {
      if (!this.dropdownAbierto) return;
      if (!this.$el?.contains(event.target)) {
        this.dropdownAbierto = '';
      }
    },
    limpiar() {
      this.resetDraft(true, !this.almacenFijoId);
    },
    async crearUbicacion() {
      if (!this.puedeCrearNueva) return;
      this.guardando = true;
      try {
        const payload = {
          id_almacen: this.almacenSeleccionado,
          nivel_1: this.nivel1Actual,
          nivel_2: this.nivel2Actual || null,
          nivel_3: this.nivel3Actual || null,
          referencia: this.referenciaLocal || null,
        };
        const { data } = await axios.post('/api/almacen/almacenes/ubicaciones/crear', payload);
        const id = data?.id_ubicacion_almacen;
        this.mensajeEstado = 'Ubicación creada correctamente.';
        this.estadoClase = 'ubicacion-selector__hint--ok';
        this.$toast?.success('Ubicación guardada correctamente.');
        this.$emit('created', {
          id_ubicacion_almacen: id,
          id_almacen: this.almacenSeleccionado,
          payload,
          response: data || null,
        });
        this.emitir({ id_almacen: this.almacenSeleccionado, id_ubicacion_almacen: id || '' });
      } catch (error) {
        this.mensajeEstado = error.response?.data?.message || 'No se pudo crear la ubicación.';
        this.estadoClase = 'ubicacion-selector__hint--error';
      } finally {
        this.guardando = false;
      }
    },
  },
};
</script>

<style scoped>
.ubicacion-selector {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}
.ubicacion-selector__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.65rem;
}
.ubicacion-selector__field {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0.32rem;
  min-width: 0;
}
.ubicacion-selector__label {
  font-size: 0.74rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: rgba(226, 232, 240, 0.88);
}
.ubicacion-selector__input,
.ubicacion-selector__control {
  width: 100%;
  border-radius: 0.82rem;
  border: 1px solid rgba(148, 163, 184, 0.38);
  background: rgba(15, 23, 42, 0.55);
  color: #e2e8f0;
  outline: none;
}
.ubicacion-selector__input {
  padding: 0.62rem 0.8rem;
}
.ubicacion-selector__input--compact {
  min-height: 2.25rem;
  padding-block: 0.52rem;
}
.ubicacion-selector__control {
  min-height: 2.25rem;
  padding: 0.52rem 0.78rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.6rem;
  text-align: left;
  cursor: pointer;
}
.ubicacion-selector__control:disabled,
.ubicacion-selector__input:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
.ubicacion-selector__control-icon {
  flex: 0 0 auto;
  opacity: 0.8;
}
.is-placeholder {
  color: rgba(148, 163, 184, 0.95);
}
.ubicacion-selector__dropdown {
  position: relative;
}
.ubicacion-selector__menu {
  position: absolute;
  top: calc(100% + 0.35rem);
  left: 0;
  right: 0;
  z-index: 30;
  border-radius: 0.95rem;
  border: 1px solid rgba(148, 163, 184, 0.28);
  background: rgba(15, 23, 42, 0.98);
  box-shadow: 0 18px 38px rgba(15, 23, 42, 0.58);
  overflow: hidden;
}
.ubicacion-selector__search {
  width: 100%;
  border: none;
  border-bottom: 1px solid rgba(148, 163, 184, 0.14);
  background: rgba(15, 23, 42, 0.98);
  color: #e2e8f0;
  padding: 0.68rem 0.78rem;
  outline: none;
}
.ubicacion-selector__options {
  max-height: 220px;
  overflow-y: auto;
  padding: 0.35rem;
  display: flex;
  flex-direction: column;
  gap: 0.22rem;
}
.ubicacion-selector__options::-webkit-scrollbar {
  width: 6px;
}
.ubicacion-selector__options::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.45);
  border-radius: 999px;
}
.ubicacion-selector__option {
  width: 100%;
  border: 1px solid transparent;
  background: transparent;
  color: #e2e8f0;
  text-align: left;
  border-radius: 0.72rem;
  padding: 0.48rem 0.6rem;
  cursor: pointer;
  font-size: 0.8rem;
}
.ubicacion-selector__option:hover,
.ubicacion-selector__option.is-selected {
  background: rgba(59, 130, 246, 0.14);
  border-color: rgba(96, 165, 250, 0.22);
}
.ubicacion-selector__option--create {
  color: #bfdbfe;
}
.ubicacion-selector__empty {
  margin: 0;
  padding: 0.5rem 0.6rem;
  font-size: 0.76rem;
  color: rgba(226, 232, 240, 0.74);
}
.ubicacion-selector__input--sub {
  margin-top: 0.1rem;
}
.ubicacion-selector__textarea {
  resize: vertical;
  min-height: 88px;
}
.ubicacion-selector__meta {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
}
.ubicacion-selector__summary {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  min-height: 1.6rem;
}
.ubicacion-selector__chip {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  border-radius: 999px;
  padding: 0.32rem 0.7rem;
  font-size: 0.72rem;
  color: #dbeafe;
  background: rgba(59, 130, 246, 0.16);
  border: 1px solid rgba(96, 165, 250, 0.28);
}
.ubicacion-selector__chip--draft {
  background: rgba(148, 163, 184, 0.12);
  color: #e2e8f0;
  border-color: rgba(148, 163, 184, 0.22);
}
.ubicacion-selector__hint {
  font-size: 0.76rem;
  color: rgba(226, 232, 240, 0.74);
}
.ubicacion-selector__hint--ok { color: #bfdbfe; }
.ubicacion-selector__hint--warn { color: #fde68a; }
.ubicacion-selector__hint--error { color: #fecaca; }
.ubicacion-selector__actions {
  display: flex;
  gap: 0.55rem;
  flex-wrap: wrap;
  justify-content: flex-end;
}
.ubicacion-selector__action {
  border: none;
  background: transparent;
  color: #93c5fd;
  font-size: 0.78rem;
  cursor: pointer;
}
.ubicacion-selector__action--primary {
  padding: 0.55rem 0.85rem;
  border-radius: 999px;
  color: #eff6ff;
  background: rgba(37, 99, 235, 0.78);
  border: 1px solid rgba(96, 165, 250, 0.28);
}
@media (max-width: 720px) {
  .ubicacion-selector__grid {
    grid-template-columns: 1fr;
  }
  .ubicacion-selector__meta {
    flex-direction: column;
  }
  .ubicacion-selector__actions {
    justify-content: flex-start;
  }
}
</style>
